import {
    Box,
    Flex,
    FormControl,
    FormErrorMessage,
    FormLabel,
    Input,
    Radio,
    RadioGroup,
    Stack,
    Text,
    Textarea,
    Checkbox
} from '@chakra-ui/react';
import SelectCountry from '../SelectCountry/SelectCountry';
import { useTranslation } from 'react-i18next';
import InlineErrorInput from "../../../../shared/components/InlineErrorInput/InlineErrorInput";
import { useFormikContext } from 'formik';
import { useEffect, useState } from 'react';

const InvoiceDetailsForm = () => {
    const { t } = useTranslation("default");
    const {
        values,
        errors,
        touched,
        setFieldValue,
        handleBlur
    } = useFormikContext();

    const [copyMainToInvoice, setCopyMainToInvoice] = useState(false);

    useEffect(() => {
        if (copyMainToInvoice) {
            const fieldsToCopy = [
                'companyName', 'nip', 'krs', 'regon',
                'country', 'postalCode', 'city', 'street', 'building', 'apartment', 'comments'
            ];

            fieldsToCopy.forEach(field => {
                const mainValue = values[field];
                if (mainValue !== undefined && mainValue !== '') {
                    setFieldValue(`invoice.${field}`, `${mainValue}`);
                }
            });
        }
    }, [copyMainToInvoice, setFieldValue]);

    return (
        <Flex flexDirection={"column"} borderRadius={'4px'}>
            <Flex gap={'32px'}>
                <Box flex="1" gap={'32px'} bgColor={"white"} pb="32px" pt={'24px'} px={'24px'} borderRadius={'4px'}>
                    <Flex flexDirection={"column"} className="header" pb={'32px'}>
                        <Text className="title">
                            {t('setup.form.invoice.title')}
                        </Text>
                        <Text className="description">
                            {t('setup.form.invoice.message')}
                        </Text>
                        <Checkbox mt={4} isChecked={copyMainToInvoice} onChange={(e) => setCopyMainToInvoice(e.target.checked)}>
                            {t('setup.form.invoice.copyMain')}
                        </Checkbox>
                    </Flex>
                    <Flex gap={'32px'} flexDirection={{ base: "column", sm: "row" }}>
                        <Box flex="1">

                            <Flex flexDirection={"column"} gap={4}>
                                <InlineErrorInput name="invoice.companyName" value={values.invoice?.companyName} label={t('setup.form.companyName.label')} isRequired />
                                <InlineErrorInput name="invoice.nip" value={values.invoice?.nip} label={t('setup.form.nip.label')} isRequired />
                                <InlineErrorInput name="invoice.email" value={values.invoice?.email} label={t('setup.form.email.label')} isRequired />
                                <Flex gap={4}>
                                    <InlineErrorInput name="invoice.krs" value={values.invoice?.krs} label={t('setup.form.krs.label')} />
                                    <InlineErrorInput name="invoice.regon" value={values.invoice?.regon} label={t('setup.form.regon.label')} />
                                </Flex>
                                <FormControl as="fieldset">
                                    <FormLabel as="legend">
                                        {t('setup.form.vatPayer.title')}
                                    </FormLabel>
                                    <RadioGroup name="invoice.vatPayer" onChange={(val) => setFieldValue('invoice.vatPayer', val)} value={values.invoice?.vatPayer || 'false'}>
                                        <Stack direction="column">
                                            <Radio value="true">{t('setup.form.yes')}</Radio>
                                            <Radio value="false">{t('setup.form.no')}</Radio>
                                        </Stack>
                                    </RadioGroup>
                                </FormControl>

                            </Flex>

                        </Box>
                        <Box flex="1" gap={4}>

                            <Flex flexDirection={"column"} gap={4}>
                                <FormControl isRequired isInvalid={errors.invoice?.country && touched.invoice?.country}>
                                    <FormLabel>{t('setup.form.country.label')}</FormLabel>
                                    <SelectCountry
                                        value={values.invoice?.country}
                                        onChange={(val) => setFieldValue('invoice.country', val, true)}
                                        onBlur={handleBlur}
                                    />
                                    <FormErrorMessage>{errors.invoice?.country}</FormErrorMessage>
                                </FormControl>
                                <Flex gap={4}>
                                    <InlineErrorInput name="invoice.postalCode" value={values.invoice?.postalCode} label={t('setup.form.postalCode.label')} isRequired />
                                    <InlineErrorInput name="invoice.city" value={values.invoice?.city} label={t('setup.form.city.label')} isRequired />
                                </Flex>
                                <Flex gap={4} alignItems={"flex-end"}>
                                    <Box flex="3">
                                        <InlineErrorInput name="invoice.street" value={values.invoice?.street} label={t('setup.form.street.label')} isRequired />
                                    </Box>
                                    <Box flex="1">
                                        <InlineErrorInput name="invoice.building" value={values.invoice?.building} label={t('setup.form.building.label')} isRequired />
                                    </Box>
                                    <Box flex="1">
                                        <InlineErrorInput name="invoice.apartment" value={values.invoice?.apartment} label={t('setup.form.apartment.label')} />
                                    </Box>
                                </Flex>
                                <FormControl>
                                    <FormLabel className="comments">
                                        <Text className="title">
                                            {t('setup.form.invoice.notes.label')}
                                        </Text>
                                    </FormLabel>
                                    <Textarea name="invoice.comments"
                                        value={values.invoice?.comments}
                                        onChange={(e) => setFieldValue('invoice.comments', e.target.value)}
                                        onBlur={handleBlur} />
                                </FormControl>

                            </Flex>

                        </Box>
                    </Flex>
                </Box>
            </Flex>
        </Flex>
    );
};

export default InvoiceDetailsForm;
